import InternalMessagingTypes from '../../store/internal-messaging/internal-messaging.types';
import { Middleware } from 'redux';
import AnyAction from '../anyActions';
import RootState from 'store/state';
import { NotificationControl } from 'utils';

export const internalMessaging: Middleware<{}, RootState> = store => next => (action: AnyAction) => {
    switch (action.type) {
        case InternalMessagingTypes.NEW_MESSAGE_NOTIFICATION:{

            const { content, user, conversationId } = action.payload;
            const { user: loggedInUser, internalMessaging } = store.getState();

            if (loggedInUser.username === user ||
                (
                    internalMessaging?.selectedConversationId === conversationId &&
                    internalMessaging.phoneBookOpen &&
                    !document.hidden
                )
            )
                return next(action);

            const notificationLength = 20;
            const message = content.length > notificationLength ?
                `${content.substring(0, notificationLength)}...` :
                content;

            new NotificationControl().send(`Message from ${user}`, message, () => {
                store.dispatch({
                    type: InternalMessagingTypes.SELECT_CONVERSATION,
                    payload: {
                        id: action.payload.conversationId
                    }
                })
                store.dispatch({
                    type: InternalMessagingTypes.OPEN_PHONEBOOK,
                    payload: true
                })
            });
            return next(action);
        }
        default:
            return next(action);
    }
};

export default internalMessaging

